import { useTranslation } from "react-i18next";

import { Dropdown } from "components";

import type { DropdownItemProps } from "components";

type ConfirmReason = {
  id: number;
  name: string;
};

export const CUSTOM_REASON = -1;

type CustomReasonsProps = {
  placeholderText?: string;
  allowCustomReason?: boolean;
  confirmReasons?: ConfirmReason[];
  handleOnChange: (reasonId?: number) => void;
};

export const CustomReasons = ({ handleOnChange, confirmReasons, allowCustomReason, placeholderText }: CustomReasonsProps) => {
  const { t } = useTranslation();

  const getOptions = (): DropdownItemProps<number>[] => {
    if (!confirmReasons) return [];

    const options = confirmReasons.map(({ id, name }) => ({ key: id, value: id, text: t(`v8_${name}`) || name }));
    return allowCustomReason ? [...options, { key: CUSTOM_REASON, text: t("v8_custom_reason_other", "Other reason"), value: CUSTOM_REASON }] : options;
  };

  return <Dropdown selection placeholder={placeholderText || t("v8_pick_reason", "Pick reason")} options={getOptions()} onChange={handleOnChange} />;
};
